const nav = (href,title,text) => `<span class="md-link" data-id="${href.substring(7)}">${text}</span>`

export const link = fallback => (href,title,text) => {
  return (href.startsWith('post?')) ? nav(href,title,text) : fallback(href,title,text)
}

